/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourseDetails } from '../models/CourseDetails';
import type { CourseDto } from '../models/CourseDto';
import type { CourseRequest } from '../models/CourseRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourseApiService {
    /**
     * @param id
     * @param requestBody
     * @returns CourseDto Success response
     * @throws ApiError
     */
    public static update2(
        id: string,
        requestBody: CourseRequest,
    ): CancelablePromise<CourseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/courses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CourseDto Success response
     * @throws ApiError
     */
    public static create2(
        requestBody: CourseRequest,
    ): CancelablePromise<CourseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/courses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get course details with hierarchical structure
     * @param courseId
     * @returns CourseDetails Course structure with modules, steps, and statuses
     * @throws ApiError
     */
    public static getCourseDetails(
        courseId: string,
    ): CancelablePromise<CourseDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses/{courseId}',
            path: {
                'courseId': courseId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
